import { setUser } from '@sentry/react'
import { Action } from 'redux'
import { Epic, ofType } from 'redux-observable'
import { catchError, EMPTY, mergeMap, of } from 'rxjs'
import { parseJwt } from '../../helpers/auth'
import { getHub } from '../../helpers/hub'
import { forceReload, logError } from '../ws/actions'
import { FetchAuthTokenSuccessAction, setAuthInitialized } from './actions'
import { State } from './reducer'
import { getIsInitialized, getUserId } from './selectors'

const keycloakAuthRefreshedEpic: Epic<Action, Action, { auth: State }> = (
  action$,
  state$
) =>
  action$.pipe(
    ofType<FetchAuthTokenSuccessAction>('auth.fetch-auth-token-success'),
    mergeMap((action) => {
      const { authToken, userName } = action.payload
      const storedUserId = getUserId(state$.value)
      const parsedToken = parseJwt(authToken)
      const userId = parsedToken.sid

      if (storedUserId && storedUserId !== userId) {
        // tslint:disable-next-line: no-console
        console.log('Invalid user in OIDC token. Refreshing page.')
        return of(forceReload())
      } else {
        // tslint:disable-next-line: no-console
        console.log('refreshing token')
        // sentry setup
        setUser({ id: userId, username: userName, ip_address: '{{auto}}' })
      }

      if (getIsInitialized(state$.value)) {
        return getHub()
          .invoke('RefreshToken', authToken)
          .pipe(
            mergeMap(() => EMPTY),
            catchError((err) => of(logError(err)))
          )
      }
      return of(setAuthInitialized())
    })
  )

export default keycloakAuthRefreshedEpic
